import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-sublist-title',
  templateUrl: './nav-sublist-title.component.html',
  styleUrls: ['./nav-sublist-title.component.scss'],
})
export class NavSublistTitleComponent {}
